export default {
  title: "FinOps & Estimation des Coûts",
  subtitle: "Analyse des coûts d'infrastructure cloud",
  kpi: {
    budgetUsage: "Utilisation Budget",
    forecast: "Prévision (30j)",
    savingsPotential: "Économies Potentielles",
    recommendations: "recommandations",
    vsbudget: "vs budget",
    projects: "Projets",
    architectures: "Architectures",
    totalCost: "Coût Total"
  },
  breadcrumb: {
    global: "Global",
    project: "Projet",
    architecture: "Architecture"
  },
  views: {
    global: "Vue Globale",
    project: "Projet",
    architecture: "Architecture",
    globalSummary: "Résumé Global",
    costsByProject: "Coûts par Projet",
    architectures: "Architectures",
    noProjectsFound: "Aucun projet trouvé",
    noArchitecturesFound: "Aucune architecture dans ce projet",
    unsupportedResources: "Ressources non estimées",
    createProject: "Créer un projet",
    createProjectCta: "Créez un projet et une architecture pour voir l'estimation des coûts.",
    noDataAvailable: "Aucune donnée disponible"
  },
  projectCard: {
    architecture: "architecture",
    architectures: "architectures",
    resource: "ressource",
    resources: "ressources",
    error: "Erreur"
  },
  costBreakdown: {
    title: "💰 Détail des coûts",
    subtitle: "Ventilation par fournisseur cloud",
    sortBy: "Trier par",
    sortByCost: "Coût (décroissant)",
    sortByName: "Nom (A-Z)",
    perMonth: "par mois",
    perHour: "heure",
    resources: "ressource",
    resources_plural: "ressources",
    ofTotal: "du total"
  },
  costChart: {
    title: "📊 Évolution des coûts",
    monthly: "Mensuel",
    yearly: "Annuel",
    comparison: "Comparaison",
    totalCost: "Coût total",
    averageCost: "Coût moyen",
    evolution: "Évolution",
    chartType: "Type de graphique",
    pieChart: "📊 Camembert",
    barChart: "📈 Barres",
    groupBy: "Grouper par",
    provider: "☁️ Provider",
    type: "🔧 Type",
    region: "🌍 Région"
  },
  resourceTypes: {
    compute: "Calcul",
    storage: "Stockage",
    database: "Base de données",
    network: "Réseau",
    other: "Autre"
  },
  fields: {
    resourceName: "Nom de la ressource",
    resourceType: "Type de ressource",
    sku: "SKU",
    region: "Région",
    monthlyCost: "Coût mensuel",
    hourlyCost: "Coût horaire",
    currency: "Devise"
  },
  messages: {
    loadError: "Erreur lors du chargement des données de coûts",
    noData: "Aucune donnée de coût disponible",
    calculating: "Calcul des coûts en cours...",
    disclaimer: "Les prix sont indicatifs et peuvent varier selon les conditions réelles d'utilisation, les réductions négociées, et les variations des tarifs des fournisseurs cloud."
  },
  export: {
    title: "Exporter l'analyse",
    pdf: "Exporter en PDF",
    excel: "Exporter en Excel",
    csv: "Exporter en CSV"
  },
  filters: {
    title: "Filtres",
    provider: "Fournisseur",
    project: "Projet",
    architecture: "Architecture",
    dateRange: "Période",
    all: "Tous"
  },
  optimization: {
    title: "Recommandations d'optimisation",
    loading: "Analyse des opportunités d'optimisation...",
    noData: "Aucune donnée d'optimisation disponible",
    noRecommendations: "Aucune recommandation pour ce filtre",
    currentCost: "Coût actuel",
    optimizedCost: "Coût optimisé",
    potentialSavings: "Économies potentielles",
    reduction: "de réduction",
    recommendationsCount: "recommandations",
    highPriority: "haute priorité",
    mediumPriority: "priorité moyenne",
    lowPriority: "priorité faible",
    all: "Toutes",
    high: "Haute priorité",
    medium: "Moyenne",
    low: "Faible",
    severity: {
      high: "Élevé",
      medium: "Moyen",
      low: "Faible"
    },
    effort: {
      low: "Faible",
      medium: "Moyen",
      high: "Élevé"
    },
    impact: {
      low: "Faible",
      medium: "Moyen",
      high: "Élevé"
    },
    details: {
      currentCost: "Coût actuel:",
      optimizedCost: "Coût optimisé:",
      effort: "Effort:",
      impact: "Impact:",
      suggestedSku: "SKU suggéré:",
      suggestedTier: "Tier suggéré:"
    }
  }
};
